import { render, staticRenderFns } from "./RemoveCentralUnit.vue?vue&type=template&id=40b4fe52&"
import script from "./RemoveCentralUnit.vue?vue&type=script&lang=js&"
export * from "./RemoveCentralUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports